/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/add_medium'
export default icon
